export default __webpack_public_path__ + "static/media/tensorflow-logo.4fbd5dc4.svg";